import { Box, HStack } from '@chakra-ui/react';
import { FeatureToggle } from '@ui/components/FeatureToggle';
import { TopNavbar } from '@ui/components/Layout/TopNavBar';
import { InDesktop, InMobile } from '@ui/components/MobileOrDesktop';
import { MAX_WIDTH } from '@ui/config/ui';
import { SEOTemplate } from '@ui/SEO';
import type { NextPage } from 'next';

import { CreateAgentModal } from '../../components/CreateAgentModal/CreateAgentModal';
import { AgentList } from './components/AgentList';
import { AgentTableFilter } from './components/AgentTableFilter';
import { Banner } from './components/Banner';
import { NewAgentButton } from './components/NewAgentButton';
import { SearchInput } from './components/SearchInput';

export const Page: NextPage = () => {
  return (
    <>
      <SEOTemplate
        title="AgentFun: Every AI Needs A Fan Club"
        description="Create AI agents that graduate into tradeable tokens when they charm their first communities! Join AgentFun, where AI meets blockchain in the coziest way possible ✧"
      />
      <TopNavbar />
      <Banner />
      <Box px="20px" pb="60px">
        <Box as="main" mx="auto" maxW={`${MAX_WIDTH}px`}>
          <HStack
            mt={{
              base: '24px',
              desktop: '40px',
            }}
          >
            <AgentTableFilter />
            <InDesktop>
              <NewAgentButton />
            </InDesktop>
          </HStack>
          <FeatureToggle flag="searchAgents">
            <SearchInput mt="8px" />
          </FeatureToggle>
          <AgentList mt="32px" />
        </Box>
      </Box>
      <InMobile>
        <Box
          p="16px 20px"
          bg="background.offWhite"
          borderTopWidth="2px"
          borderColor="text.default"
          position="fixed"
          bottom="0"
          left="0"
          right="0"
          mx="auto"
        >
          <NewAgentButton w="full" />
        </Box>
      </InMobile>
      <CreateAgentModal />
    </>
  );
};
